import { PropsWithChildren, useMemo } from 'react';

import { AuthenticationContext } from '../contexts/authentication-context';

export const NoopAuthenticationContextProvider = ({ children }: PropsWithChildren) => {
   const value = useMemo(
      () => ({
         user: undefined,
         accessToken: undefined,
         loading: false,
         canAuthenticate: true,
         refreshToken: async () => {
            // no-op
         },
         login: () => {
            // no-op
         },
         logout: () => {
            // no-op
         }
      }),
      []
   );

   return <AuthenticationContext value={value}>{children}</AuthenticationContext>;
};
